import { Dimensions } from 'modules/people_chart/lib/Dimensions'

import Group from './Group'
import Link from './Link'

export const GROUP_NODE_SIZE_COLLAPSED: Dimensions = [300, 162]
export const GROUP_NODE_SIZE_COLLAPSED_NO_MEMBERS: Dimensions = [300, 114]
const SPACE_BETWEEN_NODES = 80
export const NODE_SIZE: Dimensions = [
  GROUP_NODE_SIZE_COLLAPSED[0],
  GROUP_NODE_SIZE_COLLAPSED[1] + SPACE_BETWEEN_NODES,
]

export default {
  Group,
  Link,
}
